import React from 'react';
import PropTypes from 'prop-types';

const contactInfo = {
  email: {
    href: "mailto:contact@projectsunflowerlanyard.org",
    text: "contact@projectsunflowerlanyard.org",
    Icon: "/Assets/Images/mail.svg"
  },
  phone: {
    href: "tel:+918287026805",
    text: "+91 82870 26805",
    Icon: "/Assets/Images/phone.svg"
  }
};

const socialLinks = [
  {
    href: "https://www.linkedin.com/company/projectsunflowerlanyard/",
    Icon: "/Assets/Images/linkedin.svg",
    ariaLabel: "Visit our LinkedIn page"
  },
  {
    href: "https://www.instagram.com/projectsunflowerlanyard/",
    Icon: "/Assets/Images/instagram.svg",
    ariaLabel: "Visit our Instagram page"
  }
];

const websiteDetails = {
  title: "Website developed in 2025"
}

const ContactLink = ({ href, Icon, text }) => (
  <a
    className="inline-flex items-center gap-3 hover:text-gray-200 transition-colors"
    href={href}
  >
    <img src={Icon} className="w-6 h-6" alt={Icon.includes('mail') ? 'White outline envelope icon' : 'White phone receiver icon'} aria-hidden="false" />
    <span>{text}</span>
  </a>
);

const SocialIcon = ({ href, Icon, ariaLabel }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={ariaLabel}
    className="bg-white/20 p-2 rounded-md hover:bg-white/30 transition"
  >
    <img src={Icon} className="w-6 h-6" alt={Icon.includes('linkedin') ? 'White LinkedIn logo icon' : 'White Instagram logo icon'} aria-hidden="false" />
  </a>
);

const Footer = ({ className = "" }) => {
  return (
    <footer className={`bg-[#753ABF] text-white w-full py-6 ${className}`}>
      <div className="mx-auto max-w-7xl px-4 md:px-20 grid grid-cols-1 gap-6 md:grid-cols-3 items-center">
        <div className="text-center md:text-left">
          <ContactLink {...contactInfo.email} />
        </div>
        <div className="text-center">
          <ContactLink {...contactInfo.phone} />
        </div>
        <div className="flex flex-col items-center md:items-end gap-4">
          <div className="flex gap-4">
            {socialLinks.map((social, index) => (
              <SocialIcon key={index} {...social} />
            ))}
          </div>
          <div className="text-sm opacity-90">
            {websiteDetails.title}
          </div>
        </div>
      </div>
    </footer>
  );
};

ContactLink.propTypes = {
  href: PropTypes.string.isRequired,
  Icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

SocialIcon.propTypes = {
  href: PropTypes.string.isRequired,
  Icon: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
